import { Image } from '@spartacus/core';

import { ProductSubcategoriesDto } from '@app/core/types/product-subcategories.dto';

import { ProductSubcategories, ProductSubcategoriesCategory } from '../types';

export class DpProductSubcategoriesModel implements ProductSubcategories {
  readonly id: string;
  readonly name: string;
  readonly subcategories: ProductSubcategoriesCategory[];
  readonly url: string;
  readonly description?: string;
  readonly image?: Image;

  constructor(dto: ProductSubcategoriesDto) {
    this.id = dto.id;
    this.name = dto.name;
    this.description = dto.description;
    this.subcategories = this.#mapSabcategories(dto);
    this.url = dto.url;
    if (dto.image) {
      this.image = { url: dto.image };
    }
  }

  #mapSabcategories({ subcategories }: ProductSubcategoriesDto): ProductSubcategoriesCategory[] {
    return (subcategories || []).map(({ id, name, image }) => ({
      id,
      name,
      image: image ? { url: image } : undefined,
      url: `c/${id}`
    }));
  }
}
